import * as React from 'react';

import { TextInput } from '@abb/common-ux';

/* tslint:disable:jsx-no-lambda */
export default class Search extends React.Component<any, any> {
    public render() {
        const { filter, applyFilter, clearFilter, changeFilterField, placeholder } = this.props;
        return (
            <div className='row'>
                <div className='col-lg-12 form-group'>
                    <div className='input-group-touching'>
                        <form onSubmit={applyFilter}>
                            <TextInput name='Search' id='searchFilter' readOnly={false} inputSize='small' placeholder={placeholder}
                                labelText='' value={filter} disabled={false} onChange={changeFilterField} />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/shared/components/Search/Search.tsx